import React from 'react';
import type { Route } from './SimpleRouter';

interface NavigationProps {
  currentRoute: Route;
  onNavigate: (route: Route) => void;
}

/**
 * Navigation component for the workout diary app
 * Provides bottom navigation bar suitable for mobile use
 */
export const Navigation: React.FC<NavigationProps> = ({ currentRoute, onNavigate }) => {
  const navItems: Array<{
    route: Route;
    label: string;
    icon: string;
    disabled?: boolean;
  }> = [
    { route: 'home', label: 'Главная', icon: '🏠' },
    { route: 'exercises', label: 'Упражнения', icon: '💪' },
    { route: 'programs', label: 'Программы', icon: '📋' },
    { route: 'workout', label: 'Тренировка', icon: '🏋️‍♂️' },
    { route: 'history', label: 'История', icon: '📊' },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-4 py-2">
      <div className="flex justify-around items-center max-w-md mx-auto">
        {navItems.map(({ route, label, icon, disabled }) => (
          <button
            key={route}
            onClick={() => !disabled && onNavigate(route)}
            disabled={disabled}
            className={`
              flex flex-col items-center justify-center p-2 rounded-lg transition-colors
              ${currentRoute === route 
                ? 'text-blue-600 bg-blue-50' 
                : disabled 
                  ? 'text-gray-400 cursor-not-allowed' 
                  : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
              }
            `}
          >
            <span className="text-lg mb-1">{icon}</span>
            <span className="text-xs font-medium">{label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
};

export default Navigation;